<template>
    <div
        :class="[
            'z-date-picker',
            `z-date-picker--size-${size}`,
            {
                'z-date-picker--filter': isFilter,
                'is-disabled': disabled,
                'is-filled': isFilled,
                'is-focused': isFocused,
                'is-errored': isValid === false,
                'is-valid': isValid && !isFilter,
                'is-required': required,
            }
        ]"
    >
        <p
            class="z-date-picker__title"
            v-if="title"
            v-html="title"
        ></p>
        <div class="z-date-picker__wrapper">
            <date-picker
                ref="picker"
                v-model:value="date"
                :lang="locale"
                :range="range"
                :type="type"
                :title-format="format"
                :format="format"
                :clearable="isClearable"
                :value-type="valueType"
                :disabled-date="disabledDate"
                :popup-class="`z-date-picker-popup ${range ? 'z-date-picker-popup--range' : '' }`"
                separator=" — "
                @change="change"
                @open="isFocused = true"
                @close="isFocused = false"
            >
            </date-picker>
            <span
                v-show="placeholder"
                v-html="placeholder"
                class="z-date-picker__placeholder"
            ></span>
        </div>
        <span
            :class="[
                'z-date-picker__error',
                errorClass
            ]"
            v-html="error"
            v-if="error && !isValid"
        ></span>
    </div>
</template>

<script>
import DatePicker from 'vue-datepicker-next'
const ruLangDatePicker = require('vue-datepicker-next/locale/ru')
const enLangDatePicker = require('vue-datepicker-next/locale/en')
const cnLangDatePicker = require('vue-datepicker-next/locale/zh-cn')

export default {
    name: 'z-date-picker',
    components: {
        DatePicker
    },
    emits: [
        'update:modelValue',
        'input',
        'change'
    ],
    props: {
        modelValue: [String, Number, Array],
        range: Boolean,
        disabled: Boolean,
        clearable: {
            type: Boolean,
            default: true
        },
        required: {
            type: Boolean,
            default: false
        },
        isFilter: {
            type: Boolean,
            default: true
        },
        type: {
            type: String,
            default: 'date',
            validator: prop => ['date', 'datetime', 'year', 'month', 'time', 'week'].includes(prop)
        },
        title: String,
        valueType: {
            type: String,
            default: 'X'
        },
        placeholder: {
            type: String,
            default: ''
        },
        format: {
            type: String,
            default: 'DD.MM.YYYY'
        },
        lang: {
            type: String
        },
        disabledDate: {
            type: Function,
            default: () => {}
        },
        errorClass: {
            type: String,
            default: ''
        },
        showValidState: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'l',
            validator: prop => ['l', 'm', 's'].includes(prop)
        },
    },
    data () {
        return {
            isValid: null,
            isFocused: false,
            // date: this.value,
            localValue: '',
            error: '',
            text: {
                error: {
                    ru: 'Поле обязательно для заполнения',
                    en: 'Required field',
                    cn: '必填项'
                }
            },
            allLocales: {
                ru: ruLangDatePicker,
                en: enLangDatePicker,
                cn: cnLangDatePicker
            },
            locale: enLangDatePicker
        }
    },
    computed: {
        isFilled () {
            if (Array.isArray(this.date)) {
                return Boolean(this.date[0] && this.date[1])
            }

            return Boolean(this.date)
        },
        isClearable () {
            if (this.isFilter) return true
            return this.clearable
        },
        date: {
            get() {
                if (this.modelValue !== undefined) return this.modelValue // для работы без v-model
                return this.localValue
            },
            set(value) {
                this.localValue = value
                this.$emit('update:modelValue', value)
            }
        }
    },
    methods: {
        change (data) {
            let result = data
            if (Array.isArray(data) && !data.some((e) => e === null)) {
                const newValue = String(+data[1] + ((23 * 60 + 59) * 60 + 59))
                data.splice(1, 1, newValue)
            }
            if (Array.isArray(data) && !(data[0] && data[1])) {
                result = undefined
            }

            this.$emit('input', result)
            this.$emit('change', result)

            setTimeout(() => {
                this.validate();
            }, 0);
        },
        validate () {
            if (this.required && !this.isFilled) {
                this.isValid = false
                this.error = this.$root.localize(this.text.error)
                return
            }

            this.isValid = true
            this.error = ''
        }
    },
    mounted () {
        if (this.allLocales[this.$root.app.page.lang]) {
            this.locale = this.allLocales[this.$root.app.page.lang]
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>
